module.exports = require('./lib/stateless.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-web3-network-status/stateless.js
// module id = 483
// module chunks = 0